"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Logo = _interopRequireDefault(require("../Logo"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  name: 'Header',
  functional: true,
  components: {
    Logo: _Logo.default
  },
  render: function render(h, context) {
    var _context$scopedSlots = context.scopedSlots,
        headerMenu = _context$scopedSlots.headerMenu,
        headerRightContent = _context$scopedSlots.headerRightContent,
        logo = _context$scopedSlots.logo;
    return h("div", {
      "class": "header"
    }, [h("router-link", {
      "class": "logo",
      "attrs": {
        "to": "/"
      }
    }, [logo && logo() || h(_Logo.default)]), headerMenu && headerMenu(), headerRightContent && headerRightContent()]);
  }
};
exports.default = _default;